module.exports = __webpack_public_path__ + "img/dashboard-package-request-fail.4ccae5a0.svg";